export default "__VITE_ASSET__d31eb9c3__"